import BaseStore from 'core/stores/BaseStore';
import { action } from 'mobx';
import { SyncService } from 'common/data';

class SyncStore extends BaseStore {
	constructor(rootStore) {
		super(new SyncService(rootStore.app.baasic.apiClient));
	}

	@action.bound
	syncAsync = async sourceOfChange => {
		return await this.service.syncAsync(sourceOfChange);
	};

	@action.bound
	syncByChannelAsync = async (id, sourceOfChange) => {
		return await this.service.syncByChannelAsync(id, sourceOfChange);
	};
}

export default SyncStore;



// WEBPACK FOOTER //
// ./src/modules/sync/stores/SyncStore.js